"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AB_TESTS_HTTP_HEADER_NAME = void 0;
const tslib_1 = require("tslib");
const parse_tests_from_cookies_1 = tslib_1.__importDefault(require("./parse-tests-from-cookies"));
exports.AB_TESTS_HTTP_HEADER_NAME = 'gp-p-testgroups';
const AB_TESTS_HTTP_HEADER_SEPARATOR = ',';
const prepareABTestsHttpHeaders = (headers) => {
    if (headers === null || headers === void 0 ? void 0 : headers[exports.AB_TESTS_HTTP_HEADER_NAME]) {
        return {
            [exports.AB_TESTS_HTTP_HEADER_NAME]: headers[exports.AB_TESTS_HTTP_HEADER_NAME],
        };
    }
    if (headers === null || headers === void 0 ? void 0 : headers.cookie) {
        const tests = (0, parse_tests_from_cookies_1.default)(headers === null || headers === void 0 ? void 0 : headers.cookie);
        if (tests.length > 0) {
            return {
                [exports.AB_TESTS_HTTP_HEADER_NAME]: tests
                    .map((test) => {
                    return `${test.testName}${test.testId ? `__${test.testId}` : ''}=${test.testValue}`;
                })
                    .join(AB_TESTS_HTTP_HEADER_SEPARATOR),
            };
        }
    }
    return {};
};
exports.default = prepareABTestsHttpHeaders;
//# sourceMappingURL=prepare-abtests-http-headers.js.map